//CNS:  new tables?
//general input

import {
  ProductType,
  ProductTypeCategory,
  ProductModelClass,
  ProductModel,
  UnitSize,
  Voltage,
  ProductMotor,
  MotorType,
  FanSpeed,
  //CoilPerformanceProfile,
  AirflowProfile,
  ProjectSchedule,
  Project,
  Company,
  Brand,
  ProjectScheduleLineItem,
  ProductTypeCoilConfig,
  ProductModelUnitSize,
  ChartData,
  CoilProfile,
  AirflowVMBProfile
} from "./dbmodels";
import { ItemInputOptionDisplayRule } from "./pricing-view-models";
import { ChartDataVMB } from "./viewmodels";

//prod.CoilConfiguration
export interface CoilConfigurationViewModel {
	CoilConfigurationId?: number;
	Name?: string;
}
export interface UnitSizeViewModel {
	UnitSizeId?: number;
	Name?: string;
}
//
export interface ConfigurationTypeViewModel {
	ConfigurationTypeId?: number;
	Name?: string;
}
export interface UnitVoltageViewModel {
	UnitVoltageId?: number;
	Name?: string;
}
//air flow
export interface AirMotorTypeViewModel {
	AirMotorTypeId?: number;
	Name?: string;
}
export interface AirFanSpeedViewModel {
	AirFanSpeedId?: number;
	Name?: string;
}

//static - no table needed
export interface AirSelectByViewModel {
	AirSelectById?: number;
	Name?: string;
}

export interface AirCoilConnectionViewModel {
	AirCoilConnectionId?: number;
	Name?: string;
}
//cooling
//db - CoilRowsConfig
export interface CoilRowsConfigurationViewModel {
	CoilId?: number;
	CoilRowConfigurations?: CoilRowConfiguration[];
	Name?: string;
}

export interface CoilRowConfiguration {
	CoolCoilRows: number;
	HeatCoilRows: number;
}
export interface CoolSelectionMethodViewModel {
	CoolSelectionMethodId?: number;
	HeatSelectionMethodId?: number;
	Name?: string;
}
//static - no table needed
export interface CoolFilterMethodViewModel {
	CoolFilterMethodId?: number;
	HeatFilterMethodId?: number;
	Name?: string;
}
export interface CoolFluidTypeViewModel {
	CoolFluidTypeId?: number;
	HeatFluidTypeId?: number;
	Name?: string;
}
//heating
//db - CoilRowsConfig
export interface HeatCoilRowsConfigurationViewModel {
	HeatCoilRowsConfigurationId?: number;
	Name?: string;
}
//static
export interface HeatSelectionMethodViewModel {
	HeatSelectionMethodId?: number;
	Name?: string;
}
export interface HeatFilterMethodViewModel {
	HeatFilterMethodId?: number;
	Name?: string;
}
export interface HeatFluidTypeViewModel {
	HeatFluidTypeId?: number;
	Name?: string;
}
export interface EHeatCapacityViewModel {
	EHeatCapacityId?: number;
	Name?: string;
}
export interface ItemConfiguration {
	ItemConfigurationId?: number;
	ProjectScheduleLineItemId?: number;
	ProductType?: ProductType;
	ProductTypeCoilConfigId?: number;
	ProductTypeCoilConfig?: ProductTypeCoilConfig;
	ProductTypeCategory?: ProductTypeCategory;
	ProductModelClass?: ProductModelClass;
	Product?: ProductModel;
	ProductModelName?: string;
	ProductModelId?: number;
	ProductTypeId?: number;
	ProductTypeCategoryId?: number;
	ProductModelClassId?: number;
	ItemQty?: number;
	ItemTag?: string;
    //cns: move to CoilRowConfigurationTypeId
	CoilRowConfigurationType?: number;
	//CoilRowConfigurationTypeId?: number;
	UnitSize?: UnitSize; //replace with ProductModelUnitSize
	Voltage?: Voltage;
	VoltageCode?: string;
	MotorHP?: number;
	UnitPrice?: number;
	TotalPrice?: number;
}

export interface CoilRowConfigurationType {
	id?: number;
	Name: string;
}

export interface PerformanceCoilRowOptionsRequest {
	ProductModelName?: string;
	ProductTypeCoilConfigId?: number;
}
export interface PerformanceCoilRowOptionsResponse {
	Request?: PerformanceCoilRowOptionsRequest;
	CoolingCoilRowOptions?: number[];
	HeatingCoilRowOptions?: number[];
	ChangeOverCoilRowOptions?: number[];
}

export interface AirflowConfiguration {
	AirflowConfigurationId?: number;
	ProjectScheduleLineItemId?: number;
    MotorType?: MotorType;
	MotorTypeId?: number;
	FanSpeedId?: number;
	ActualAirflowCFM?: number;
	OutsideAirflowCFM?: number;
	ESP?: number;
	CoilConnectionSide?: number;
	AirflowSelectionType?: number;
	Altitude?: number;

	//Pressure Drop Adjustment
	FilterPressureTargetCFM?: number;
	MERVFilterTypeName?: string;
	FilterThickness?: number;  //1,2,4
	MERVCodeStringValue?: string;
	MotorFanHPDisplayName?: string;
	MotorRPM?: string;
  	FanMotorBHP?: string;
	UseRelativeHumidity?: boolean;
}

export interface CoolingCoilConfiguration {
	CoolingCoilConfigurationId?: number;
	ProjectScheduleLineItemId?: number;
	EnteringAirTempDB?: number;
    EnteringAirTempWB?: number;
	RelativeHumidity?: number;
    EnteringFluidTemp?: number;
    CoilRows?: number;  //select from drop down
    SelectionMethodId?: number;  //select from drop down
	LeavingFluidTemp?: number;
	FluidFlowGPM?: number;
	FilterMethodId?: number; //select from drop down
	TotalCapacity?: number;
	LeavingAirTemp?: number;
	LeavingAirTempDB?: number;
	LeavingAirTempWB?: number;
	MaxFluidPressureDrop?: number;
	FluidType?: number; //select from drop down
	VolumeGlycol?: number;
	IsActive?: boolean;
	TotalCapacityAlt?: number;      
  	SensibleCapacity?: number;      
  	EnergyRejectedMBH?: number;      
  	FluidPressureDrop?: number;      
	AirPressureDrop?: number; // Air Pressure Drop in inches of water	
  	EER?: number;                    	
  	Watts?: number;                 
}

//revesit naming in a standalone release
//AirConfiguration is separate from AirflowConfiguration
export interface WSHPCoilConfiguration {
	//WSHPCoilConfigurationId?: number;
	ProjectScheduleLineItemId?: number;
	WSHPCoolingEnteringAirTempDB?: number;
    WSHPCoolingEnteringAirTempWB?: number;
    WSHPCoolingEnteringFluidTemp?: number;
    //WSHPCoilRows?: number;  //select from drop down
    WSHPCoolingSelectionMethodId?: number;  //select from drop down
	WSHPCoolingLeavingFluidTemp?: number;
	WSHPCoolingFluidFlowGPM?: number;
	WSHPCoolingFilterMethodId?: number; //select from drop down
	WSHPCoolingTotalCapacity?: number;
	WSHPCoolingLeavingAirTemp?: number;
	WSHPCoolingMaxFluidPressureDrop?: number;
	WSHPCoolingFluidTypeId?: number; //select from drop down
	WSHPCoolingVolumeGlycol?: number;
	IsActive?: boolean;

    //heating fields
    //WSHPHeatingEnteringAirTemp?: number;
	WSHPHeatingEnteringAirTempDB?: number;
	WSHPHeatingEnteringAirTempWB?: number;
    WSHPHeatingEnteringFluidTemp?: number;
	WSHPHeatingFluidFlowGPM?: number;
}

export interface ERVConfiguration {
	SummerSupply: SeasonInput;
	WinterSupply: SeasonInput;
	SummerReturn: SeasonInput;
	WinterReturn: SeasonInput;

	FramedBase?: number;
	Height?: number;

	UseRelativeHumidity?: boolean;
	UseElevation?: boolean;
	PressureMbar?: number;
	ElevationFt?: number;

	UseMetric?: boolean;

	SupplyPitch?: number;
	ReturnPitch?: number;

	IsActive?: boolean;
}



export interface SeasonInput {
	WetBulb?: number;
	DryBulb: number;
	Airflow: number;
	RelativeHumidity?: number;
}

export interface HeatingCoilConfiguration {
	HeatingCoilConfigurationId?: number;
	ProjectScheduleLineItemId?: number;
	EnteringAirTempDB?: number;
	EnteringAirTempWB?: number;
	EnteringFluidTemp?: number;
    CoilRows?: number;  //select from drop down
    SelectionMethodId?: number;  //select from drop down
	LeavingFluidTemp?: number;
	FluidFlowGPM?: number;
	FilterMethodId?: number; //select from drop down
	TotalCapacity?: number;
	LeavingAirTemp?: number;
	MaxFluidPressureDrop?: number;
	FluidType?: number; //select from drop down
	VolumeGlycol?: number;
	IsActive?: boolean;
	TotalCapacityAlt?: number; // From modelSummaryData JSON
	SensibleCapacity?: number;  
	EnergyAbsorbedMBH?: number; 
	FluidPressureDrop?: number;  
	AirPressureDrop?: number; // Air Pressure Drop in inches of water	  
	COP?: number;                    
	Watts?: number;                  
	KW?: number;                      
    SteamPressure?: number;    
}

export interface ElectricHeatingConfiguration {
	CapacityWatts?: string;
	EnteringAirTemp?: number;
	IsActive?: boolean;
}

type Mutable<T> = {
	-readonly [k in keyof T]: T[k];
 };

 export interface ProjectScheduleGridColumn{
	ProjectScheduleLineItemId?: number;
	ProjectScheduleId?: number;
	CsiTranslation?: CsiTranslation;
	IsProductSummaryPdfSaved: boolean;
	ProductModelDescription: string;
	UnitPrice?: number;
	FinalPrice?: number;
	ProductTypeName: string;
	SelectionMap?: ConfigurationSet;
	UnitSpecifications?: UnitSpecifications;
	CodeStringGroupValues?: CodeStringGroupValue[];
	CertPerfData?: string;
	AHRICertNumber?: string;

	IsActive?: boolean;
}
export interface CsiTranslation{
	CSITranslationNumber?: string;
	ConfigurationDisplayName?: string;
	ConfigurationTranslation?: string;
	PrimaryCircuitDisplayName?: string;
	PrimaryCircuitTranslation?: string;
	SecondaryCircuitDisplayName?: string;
	SecondaryCircuitTranslation?: string;
	DischargeGrilleDisplayName?: string;
	DischargeGrilleTranslation?: string;
	ReturnAirPanelDisplayName?: string;
	ReturnAirPanelTranslation?: string;
}

export interface CodeStringGroupValue{
	GroupName: string;
	GroupDisplayName: string;
	CodeStringDisplayValue: string;
}
 
export interface UnitSpecifications {
	unitMCA: number;
	unitMCAMFS?: string;
	unitMFS: number;
	unitVoltage?: string;
	unitAmps: number;
	unitHeightIn: number;
	unitLengthIn: number;
	unitWidthIn: number;
	unitWeightLb: number;
	altitudeFt: number;
	dateCreated: string; // ISO string for DateTime
	dateModified?: string; // nullable DateTime
	createdBy: string;
	lastModifiedBy?: string;
}
export interface ConfigurationSet {
	ItemConfiguration?: ItemConfiguration;
	AirflowConfiguration?: AirflowConfiguration;
	CoolingCoilConfiguration?: CoolingCoilConfiguration;
	HeatingCoilConfiguration?: HeatingCoilConfiguration;
	ElectricHeatingConfiguration?: ElectricHeatingConfiguration;
	ERVConfiguration?: ERVConfiguration;
}

export interface PerformanceRequest {
	Selections?: ConfigurationSet;
	ProductModelUnitSizes?: ProductModelUnitSize[];
	ProjectId?: number;
	ProjectScheduleId?: number;
}
export interface PerformanceResponseWSHP {
	PerformanceRequest: PerformanceRequest;
	HeatingParameters: JSON;
	CoolingParameters: JSON;
	MatchedModels: WSHPDisplayResult[];
	NotMatchedModels: WSHPDisplayResult[];
	GeneralNotMatchedReasons: string[];
}
export interface PerformanceResponseBlowerCoils{
	Request: PerformanceRequest;
	MatchedModels: ModelResultRR[];
	NotMatchedModels: ModelResultRR[];
	HasErrors?: boolean;
	GeneralNotMatchedReasons: string[];
	UserMessage?: string;
	BlowerCoilPerformanceData: BlowerCoilPerformanceData;
}

export interface BlowerCoilPerformanceData {
	BlowerCoilPerformances?: BlowerCoilPerformance[];
}

export interface PerformanceResponseERV {
	Request: PerformanceRequest;
	HasErrors?: boolean;
	UserMessage?: string;
	//results?: FilteredResultRR[];
	//NotMatchedModels?: NotMatchedReason[];
	MatchedModels?: ModelResultRR[];
	NotMatchedModels?: ModelResultRR[];
	GeneralNotMatchedReasons?: string[];
	SummerOutput?: SeasonERVOutput;
	WinterOutput?: SeasonERVOutput;
}

export interface SeasonERVOutput {
	DryBulbTemperature?: number;
	WetBulbTemperature?: number;
	RelativeHumidity?: number;
	SensibleEffectiveness?: number;
	LatentEffectiveness?: number;
	TotalEffectiveness?: number;
	MoistureRatio?: number;
	EnergySavings?: number;
}

export interface ProductModelWheel {
	ProductModel?: ProductModel;
	ProductModelId?: number;
	WheelId?: number;
	Wheel?: Wheel;
	UnitSizeId?: number;
	UnitSize?: UnitSize;
	MinAirflow?: number;
	MaxAirflow?: number;
	MinRPM?: number;
	MaxRPM?: number;
}

export interface BlowerCoilPerformance {
	ProductModelWheel?: ProductModelWheel;
	CFM?: number;
	ESP?: number;
	BHP?: number;
	RPM?: number;
	CoilRows?: number;
	Voltage?: Voltage;
	BlowerCoil?: BlowerCoilData;
	HeatingCoilProfile?: CoilProfile;
	CoolingCoilProfile?: CoilProfile;
}

export interface BlowerCoilData {
	BlowerCoilId?: number;
	Name?: string;
	UnitSizeId?: number;
	ProductModelId?: number;
	HP?: number;
	VoltageId?: number;
	RPMMin?: number;
	RPMMax?: number;
	DriveKitName?: string;
	MotorName?: string;
	
}

export interface Wheel {
	WheelId?: number;
	Name?: string;
	Description?: string;
	Dimensions?: string;
}

export interface BlowerCoilDisplayResult {
	ModelResultId?: string;
	ModelString: string;
	ModelLabel: string;
	ProductModel: ProductModel;
	ProductModelClass: ProductModelClass;
	ProductModelUnitSize?: ProductModelUnitSize;
	VoltageCode?: string;

	AirflowProfile?: AirflowProfile;
	ChartData: ChartData;

	NotMatched?: boolean;
	NotMatchedReasons?: string[];

	AirDisplayResult?: WSHPAirDisplayResult;
	CoolingDisplayResult?: WSHPCoolingDisplayResult;
	HeatingDisplayResult?: WSHPHeatingDisplayResult;
	ElectricalDisplayResult?: WSHPElectricalDisplayResult;
}

export interface ProjectScheduleLineItemCreateResponse {
	HasErrors?: boolean;
	UserMessage?: string;
	ProjectScheduleLineItem?: ProjectScheduleLineItem;
}
export interface ProjectScheduleLineItemUpdateResponse {
	HasErrors?: boolean;
	UserMessage?: string;
	ProjectScheduleLineItem?: ProjectScheduleLineItem;
	PriceChange?: boolean;
}

export interface NotMatchedReason {
	ModelLabel?: string;
	Reasons?: string[];
}

export interface WSHPDisplayResult {
	ModelResultId?: string;
	ModelString: string;
	ModelLabel: string;
	ProductModel: ProductModel;
	ProductModelClass: ProductModelClass;
	ProductModelUnitSize?: ProductModelUnitSize;
	VoltageCode?: string;

	AirflowProfile?: AirflowProfile;
	ChartData: ChartData;
	FanCurveData: FanCurveData;

	NotMatched?: boolean;
	NotMatchedReasons?: string[];

	AirDisplayResult?: WSHPAirDisplayResult;
	CoolingDisplayResult?: WSHPCoolingDisplayResult;
	HeatingDisplayResult?: WSHPHeatingDisplayResult;
	ElectricalDisplayResult?: WSHPElectricalDisplayResult;
}
export interface WSHPAirDisplayResult {
	TotalAirflowCFM?: string;
	ExternalStaticPressureIWG?: string;
	AirPressureDropWG?: string;
	MotorFanSpeed?: FanSpeed;
}
export interface WSHPCoolingDisplayResult {
	TotalCapacityMBH?: string;
	SensibleNetCapacityMBH?: string;
	LeavingFluidTempF?: string;
	LeavingAirTempDBF?: string;
	LeavingAirTempWBF?: string;
	EER?: string;
	RejectedMBH?: string;
	FluidFlowGPM?: string;
	FluidPressureDrop?: string;
}
export interface WSHPHeatingDisplayResult {
	TotalCapacityMBH?: string;
	SensibleNetCapacityMBH?: string;
	LeavingFluidTempF?: string;
	EnteringAirTempDBF?: string;
	LeavingAirTempDBF?: string;
	LeavingAirTempWBF?: string;
	COP?: string;
	FluidFlowGPM?: string;
	EnergyAbsorbed?: string;
	FluidPressureDrop?: string;
}	
export interface WSHPElectricalDisplayResult {
	VoltagePhHz?: string;
	//MCAoverMFS?: string;
	ItemConfigMotor: ItemConfigMotorLookup;
}
export enum CoilConfigurationTypeEnum {
    HotWater = 1,
    ChilledWater = 2,
    ChangeOver = 3,
    HeatedChilled = 4
}

export enum ProductTypeEnum {
    FanCoil = 1,
    BlowerCoil = 2,
    WSHP = 3,
    ECO = 4,
	Console = 6,
	Residential = 7

}
export interface ItemProductSummary {
	ChartData?: ChartData;
	FanCurveData?: FanCurveData; //fan curve data used in the chart component
	AllFanSpeedFanCurveData?: FanCurveData; //For all motor fan speeds
	ProductTypeId?: number;
	ProjectScheduleLineItem?: ProjectScheduleLineItem;
	Project: Project;
	ProjectCompany?: Company;
	ProjectBrand?: Brand;
	ProjectSchedule?: ProjectSchedule;
	ProductModel?: ProductModel;
	ProductModelUnitSize?: ProductModelUnitSize;
	Selections?: ConfigurationSet;
	ModelGridData?: ResultsModelGridData;
	//Line Item may not exist yet so need 
	PerformanceData?: any; //can be fancoil or wshp
	MatchedModel?:any;
}

export interface ResultsGridData {
    ModelResults: ResultsModelGridData[];
}
export interface ResultsModelGridData {
	Index?: number;
	ModelResultId?: string;
	ModelString: string; //never changes - reflects model string of result
	ModelLabel: string;  //may change on presentation need within grid
	ProductModel: ProductModel;
	ProductModelUnitSize: ProductModelUnitSize;	
	//ModelResults: ModelResultRR | WSHPDisplayResult;
	NameValue: Record<string, string>;
	//NameValue?: NameValuePair[];
	Items: ResultsModelGroupsGridData[];
	ChartData: ChartData;
	ChartDataHtml?: string;
	FanCurveData?: FanCurveData; //fan curve data used in the chart component
}
export interface ResultsModelGroupsGridData {
	GroupLabel: string;
	Items: ResultsModelItemGridData[];
}
export interface ResultsModelItemGridData {
	ItemLabel: string;
	Value: string;
}

/* export interface R_RResults {
	rows: number;
	CoilModel: string;
	CoilHeight: number;
	CoilLength: number;
	FPI: number;
	Rows: number;
	CKTS: number;
	Tubes: number;
	FlowType: string;
	FinDensity: number;
	Material: string;
	TubeWall: number;
	Treatment: string;
	HDR: number;
	HDRLen: number;
	CONN: number;
	NumberOfConnections: number;
	FoulFactor: number;
	FluidType: string;
	FluidEnteringTemp: number;
	GPM: number;
	CFM: number;
	STD_ACT: string;
	FPM: number;
	FanWatts: number;
	RFW: number;
	DryBulb: number;
	WetBulb: number;
	NQT_QT: number;
	NQS_QS: number;
	DB_LEV: number;
	WB_LEV: number;
	FLD_LV: number;
	WG: number;
	COILPD: number;
	REYN: number;
	LATENT: number;
	INT_VOL: number;
	LB_TUBE: number;
	LB_FIN: number;
	CODE: number;
	QT_E3: number;
	QS_E3: number;
	QL_E3: number;
	maxCapacity: number;
	nominalCapacity: number;
	coilPressureDrop: number;
}
 */
/* export interface FilteredResultRR {
	productModel: ProductModel;
	unitSize: UnitSize;
	motor: Motor;
	voltage: Voltage;
	fanSpeed: FanSpeed;
	heatingCalcResults: R_RResults;
	coolingCalcResults: R_RResults;
	calcResults: R_RResults[];
	coilPerformanceProfiles?: CoilPerformanceProfile[];
	airflowProfiles?: AirflowProfile[];
	gridDataPoints?: GridDataPoint[];
} */

export interface PerformanceResponseFanCoil {
	Request: PerformanceRequest;
	HasErrors?: boolean;
	UserMessage?: string;
	//results?: FilteredResultRR[];
	//NotMatchedModels?: NotMatchedReason[];
	MatchedModels?: ModelResultRR[];
	NotMatchedModels?: ModelResultRR[];
	GeneralNotMatchedReasons?: string[];
}

export interface ItemConfigMotorLookup {
	ProductModelName?: string;
	UnitSizeName?: string;
	MotorTypeName?: string;
	VoltageId?: number;
	KilWatts?: number;
	UnitDescription?: string;
	MCA?: number;
	MOP?: number;
	Qty?: number;
	HPDisplayName?: string;
	Voltage: Voltage;
	RLA?: number;
	FLA?: number;
	MotorType?: MotorType;
}

export interface ModelResultRR {

	ModelResultId?: string;

	NotMatched?: boolean;
	NotMatchedReasons?: string[];
	ModelLabel?: string;

	ProductModel: ProductModel;
	ProductModelUnitSize: ProductModelUnitSize;
	MotorType: MotorType;
	MotorFanSpeed: FanSpeed;
	MotorFanSpeedLabel?: string; //display label for fan speed, initially for VMB
	ProductTypeCoilConfig: ProductTypeCoilConfig;
	MotorRPM?: string;
	Voltage?: Voltage;
	FLA?: number;

	ItemConfigMotor: ItemConfigMotorLookup;

	BlowerCoilData?: BlowerCoilData;

	ESPDisplayDescription?: string;

	ChartData?: ChartData;  //airflow profile chart data - not same one used in the chart component

	//based on points of multiple lines and user input point
	FanCurveData?: FanCurveData; //fan curve data used in the chart component

	//VMB could be in a child class
	AirflowVMBProfiles?: AirflowVMBProfile[];
	AirflowProfile?: AirflowProfile;
	CoolingPerformance?: ResultsRR;
	HeatingPerformance: ResultsRR;



}

export interface ModelResultVMB extends ModelResultRR {

}

export interface GraphPoint {
	X: number;
	Y: number;
}
export interface FanCurveLine {
	//maps to C# tuple
	Label?: string; //line label
	Points?: GraphPoint[]; //line points
	
	//legacy support - api creates from points
	ESP?: number[]; 
	CFM?: number[];
}

export interface FanCurveData {
	//FanCurveId?: number;
	FanCurveLines?: FanCurveLine[];
	UserPoint?: {X: number, Y: number}; //user input point (x:CFM, y: ESP)
	FanSpeedName?: string; //name of the target fan speed for the curve
}

export interface ResultsRR {
	HasErrors?: boolean;
	Errors?: string[];


	CoilProfileId?: number;
	CoilModel?: string;
	CoilHeight?: number;
	CoilLength?: number;
	FPI?: number;
	Rows?: number;

	CKTS: number;
	Tubes: number;
	FlowType: string;
	FinDensity: number;
	Material: string;
	TubeWall: number;
	Treatment: string;
	HDR: number;
	HDRLen: number;
	CONN: number;
	NumberOfConnections: number;
	FoulFactor: number;
	FluidType: string;
	FluidEnteringTemp: number;
	GPM: number;
	CFM: number;
	STD_ACT: string;
	FPM: number;
	FanWatts: number;
	RFW: number;
	DryBulb: number;
	WetBulb: number;
	NQT_QT: number;
	NQS_QS: number;
	DB_LEV: number;
	WB_LEV: number;
	FLD_LV: number;
	FIN_OUTPUT: string; //value in FLD_LV field when using GPM as a coil Selection Method
	WG: number;
	COILPD: number;
	REYN: number;
	LATENT: number;
	INT_VOL: number;
	LB_TUBE: number;
	LB_FIN: number;
	CODE: number;
	QT_E3: number;
	QS_E3: number;
	QL_E3: number;

	maxCapacity: number;
	nominalCapacity: number;
	coilPressureDrop: number;

}

export interface GridDataPoint {
	X: number;
	Y: number;
}
export enum NotificationTypeEnum {
	Success = 'Success',
	Error = 'Error',
	Info = 'Info',
	Warning = 'Warning'
}
export const NotificationConfig = {
	[NotificationTypeEnum.Success]: {
	  name: 'Success',
	  cssClass: 'd-n-success',
	  icon: 'checkmark-circle',
	  color: '#3ca362',
	  bgcolor: '#f0fdf4f2'
	},
	[NotificationTypeEnum.Error]: {
	  name: 'Error',
	  cssClass: 'd-n-error',
	  icon: 'close-circle',
	  color: '#fa3333',
	  bgcolor: '#fdf4f4'
	},
	[NotificationTypeEnum.Info]: {
	  name: 'Info',
	  cssClass: 'd-n-info',
	  icon: 'information-circle',
	  color: '#235ca2',
	  bgcolor: '#f0f2fdf2'
	},
	[NotificationTypeEnum.Warning]: {
	  name: 'Warning',
	  cssClass: 'd-n-warning',
	  icon: 'warning',
	  color: '#f8cb5a',
	  bgcolor: '#fdfaf0f2'
	}
};
  export interface ToastOptions {
	notificationType: NotificationTypeEnum;
	message: string;
	timeInMs?: number;              // how long to show (ms)
	persistent?: boolean;           // if true, stays until user dismisses
	cssClass?: string;
	onDismissCallback?: Function;

  }
  export interface ModalConfirmationProps {
	header: string;
	message: string;
	acceptBtnName?: string;
	rejectBtnName?: string;
	onAccept: () => void | Promise<void>;
	onReject?: () => void;
  }
  export interface ModalAlertProp {
	header: string;
	message: string;
	notificationType: NotificationTypeEnum;
	acceptBtnName?: string;
	onConfirmation?: () => void; 
	onCounterElapsed?: () => void; 
	counter?: number;
  }

  export enum UserRoleEnum {
	SysAdmin = 'SysAdmin',
	AppAdmin = 'AppAdmin',
	VPPricingDirector = 'VPPricingDirector',
	RegionalSalesManager = 'RegionalSalesManager',
	InsideSalesAccount = 'InsideSalesAccount',
	ApplicationEngineering = 'ApplicationEngineering',
	OrderProcessing = 'OrderProcessing'
  }
  export class AppDtoResponse {
	Response?: any;
	ResponseTypeEnum: ResponseTypeEnum; 
	public Success: boolean = false;
	public Message: string;
	public Exception?: string;
	public WarningMessages: string[] = [];
  }
  
  
export enum ResponseTypeEnum {
	Success = 1,
	Warning = 2,
	Info = 3,
	Error = 4

}

//use the following class to enable easy lookup of the product model tree
export interface ProductModelViewModel extends ProductModel {

	ProductTypeId?: number;
	ProductType: ProductType;
	ProductTypeCategoryId?: number;
	ProductTypeCategory: ProductTypeCategory;
	ProductModelClassId?: number;
	ProductModelClass: ProductModelClass;

}

export interface ItemConfigurationHeaderViewModel {

	lineItemId?: number;

	ProductTypeId?: number;
	ProductTypeCategoryId?: number;
	ProductModelClassId?: number;
	ProductModelId?: number;
	ProductType?: ProductType;
	ProductTypeCategory?: ProductTypeCategory;
	ProductModelClass?: ProductModelClass;
	ProductModel?: ProductModel;

	ItemTag?: string;
	ItemQty?: number;

}


export interface FilterPressureDropParameter {
	RatingName?: string;
	InchThickness?: number;
	CoefficientName?: string;
	DisplayName?: string;
	CoefficientValue?: number;
	CodeStringValue?: string;
}
export interface FilterPressureDropDataRequest {
	ProductModelName?: string;
}
export interface FilterPressureDropDataResponse {
	FilterPressureDropParameters?: FilterPressureDropParameter[];
}
export interface NameValuePair {
	Name?: string;
	Value?: string | number;
}

export interface FileDownloadOptions {
  url: string;
  fileName?: string;
  download?: boolean;
  openInNewTab?: boolean;
}
// export class GraphPoint {
//   constructor(
//     public x: number = 0,
//     public y: number = 0
//   ) {}
// }

// export class FanCurveLine {
//   label: string = '';
//   unitDescription: string = '';
//   points: GraphPoint[] = [];

//   constructor(points: GraphPoint[] = [], label: string = '', unitDescription: string = '') {
//     this.points = points;
//     this.label = label;
//     this.unitDescription = unitDescription;
//   }

//   get esp(): number[] {
//     return this.points.map(p => p.y);
//   }

//   get cfm(): number[] {
//     return this.points.map(p => p.x);
//   }
// }

// export class FanCurveData {
//   unitSizeName: string = '';
//   fanCurveLines: FanCurveLine[] = [];
//   userPoint: GraphPoint = new GraphPoint(0, 0);
// }